module.exports = __webpack_public_path__ + "assets/bdf70f0276ebc72d0541f40ef27ca05b.png";